import {Button, CircularProgress, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import './daily-care-log-form-footer-buttons.scss';

type DailyCareLogFormFooterButtonsProps = {
  canWrite: boolean;
  editMode: boolean;
  isCancelDisabled: boolean;
  isCancelVisible?: boolean;
  isSaveDisabled: boolean;
  isSaveLoading?: boolean;
  saveLabel?: string;
  onCancel: () => void;
  onSave: () => void;
  onEdit: () => void;
};

export const DailyCareLogFormFooterButtons = ({
  canWrite,
  editMode,
  isCancelDisabled,
  isCancelVisible = true,
  isSaveDisabled,
  isSaveLoading,
  saveLabel,
  onCancel,
  onSave,
  onEdit,
}: DailyCareLogFormFooterButtonsProps) => {
  const {t} = useTranslation();

  return (
    <Stack className="action-buttons-container">
      {canWrite ? (
        editMode ? (
          <Stack className="action-buttons">
            {isCancelVisible && (
              <Button
                variant="text"
                size="large"
                color="error"
                disabled={isCancelDisabled}
                onClick={onCancel}
              >
                {t(translations.daily_care_log.task_details.cancel)}
              </Button>
            )}
            <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={onSave}
              disabled={isSaveDisabled || !!isSaveLoading}
              startIcon={
                isSaveLoading && (
                  <CircularProgress size={16} style={{color: 'var(--dcm-gray-light)'}} />
                )
              }
            >
              {saveLabel || t(translations.daily_care_log.task_details.save)}
            </Button>
          </Stack>
        ) : (
          <Stack className="action-buttons">
            <Button
              variant="text"
              size="large"
              color="primary"
              onClick={onEdit}
              sx={{textDecoration: 'underline'}}
            >
              {t(translations.daily_care_log.task_details.edit_entry)}
            </Button>
          </Stack>
        )
      ) : (
        <Stack className="action-buttons">
          <Button variant="text" size="large" color="error" onClick={onCancel}>
            {t(translations.daily_care_log.task_details.cancel)}
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
